import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { logoutApp } from "../../../features/auth/logout";
import { useAppSelector } from "../../../stateManagement/hooks/redux";
import { applyUserMessageWindowOpened, setSidebarMenuPath } from "../../../stateManagement/reducers/SidebarBlockSlice";
import { typesRequiringPathId } from "./menuListFunctions";
import { Tooltip } from "primereact/tooltip";
import { getItemWebStorage, setItemWebStorage } from "../../../features/webStorageSaver";
import { getIndorImageSrc } from "../../../features";

const rightArrowSrc = require('../../../assets/images/fontAwesomeIcons/chevron-right-solid.svg').default

export default function MenuListItem({ id, type, index, title, imageIndex, imageType, url, hasChildren }: any) {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const location = useLocation()
    const currentMenuPath = useAppSelector(state => state.sidebar.sidebarMenuPath)
    const pathId = useAppSelector(state => state.pathsInfo.selectedPath?.pathId)
    const [isActive, setIsActive] = useState<boolean>(false)
    const [isDisabled, setIsDisabled] = useState<boolean>(typesRequiringPathId.includes(type))

    function changeCurrentMenuPath() {
        if (hasChildren) {
            const newMenuPath = [...currentMenuPath, index]
            dispatch(setSidebarMenuPath(newMenuPath))
            const sidebarLocalSettings = getItemWebStorage('sidebar')
            const newSidebarSettings = {
                ...sidebarLocalSettings,
                menuPath: newMenuPath
            }
            setItemWebStorage('sidebar', newSidebarSettings)
        }
        if (url) {
            navigate(url)
        }
    }

    function menuListItemClick() {
        if (!isDisabled) {
            if (type === 'feedback') {
                dispatch(applyUserMessageWindowOpened(true))
            } else if (type === 'exit') {
                logoutApp()
            } else {
                changeCurrentMenuPath()
            }
        }
    }

    useEffect(() => {
        setIsActive(location.pathname === url)
    }, [location])

    useEffect(() => {
        const isDisabled = !pathId && typesRequiringPathId.includes(type)
        setIsDisabled(isDisabled)
    }, [pathId])

    function getMenuItemImageSrc(imageIndex: string) {
        try {
            return require(`../../../assets/images/icons/menuItems/${imageIndex}.png`)
        } catch {
            console.error(`Ошибка загрузки изображения ${imageIndex}`)
        }
    }

    return (
        <>
            {isDisabled &&
                <Tooltip target={`.${id}`} mouseTrack mouseTrackLeft={15} />
            }
            <div
                className={`menu-list-item ${id}` + (isActive ? ' active' : '') + (isDisabled ? ' disabled' : '')}
                onClick={menuListItemClick}
                data-pr-tooltip={isDisabled ? "Не выбрана дорога" : ''}
            >
                {imageType === "localIcon"
                    ?
                    <img className="menu-list-item-img" src={getMenuItemImageSrc(imageIndex)} />
                    :
                    <img className="menu-list-item-img" src={getIndorImageSrc(imageIndex)} />
                }
                <span className="menu-list-item-title">{title}</span>
                {hasChildren &&
                    <img className="menu-list-item-right-arrow-img" src={rightArrowSrc} />
                }
            </div>
        </>
    )
}
